import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=3b40b08c&scoped=true"
import script from "./HoverMenu.vue?vue&type=script&lang=js"
export * from "./HoverMenu.vue?vue&type=script&lang=js"
import style0 from "./HoverMenu.vue?vue&type=style&index=0&id=3b40b08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40b08c",
  null
  
)

export default component.exports